import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Works from './views/Works.vue'

Vue.use(Router)

export default new Router({

  mode: 'history',
  base: process.env.BASE_URL,

  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve( savedPosition || { x: 0, y: 0 } )
      }, 300)
    })
  },

  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/works',
      name: 'works',
      component: Works
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(
        /* webpackChunkName: "about" */
        './views/About.vue')
    },

    /*   WORKS
         =====   */

    {
      path: '/works/21stclub-evolution',
      name: 'works-21stclub-evolution',
      component: () => import(
        './views/Works.21stClubEvolution.vue')
    },
    {
      path: '/works/futr-chatamo',
      name: 'works-futr-chatamo',
      component: () => import(
        './views/Works.FutrChatamo.vue')
    },
    {
      path: '/works/showcode',
      name: 'works-showcode',
      component: () => import(
        './views/Works.ShowCode.vue')
    },
    {
      path: '/works/the-coaching-manual',
      name: 'works-the-coaching-manual',
      component: () => import(
        './views/Works.TheCoachingManual.vue')
    },
    {
      path: '/works/gwi-survey-dashboard',
      name: 'works-gwi-survey-dashboard',
      component: () => import(
        './views/Works.GWISurveyDashboard.vue')
    },
    {
      path: '/works/wired-magazine',
      name: 'works-wired-magazine',
      component: () => import(
        './views/Works.WiredMagazine.vue')
    },


    /*   IMPORTANT
         =========   */

    {
     path: '/terms-of-use',
     name: 'terms-of-use',
     component: () => import(
       './views/TermsOfUse.vue')
    },
    {
     path: '/cookies',
     name: 'cookies',
     component: () => import(
       './views/Cookies.vue')
    },
    {
     path: '/privacy-policy',
     name: 'privacy-policy',
     component: () => import(
       './views/PrivacyPolicy.vue')
    }

  ]
})
